<!-- 菜单页 -->
<template>
  <div class="menu">
    <ul v-for="(menu, index) in menus" :key="index" class="menu-item">
      <li
        class="menu-item-title"
        @mouseenter="handleMouseEnter(index)"
        @mouseleave="handleMouseLeave"
        :class="{ active: isActive(menu), text: isTitleActive(menu) }"
      >
        <span class="title_text" @click="handleMenuClick(menu)">
          {{
            menu.titleKey === "产品中心"
              ? menu.titleKey
              : $t("system.home.menu." + menu.titleKey)
          }}
        </span>
        <!-- 一级下拉菜单 -->
        <ul v-if="menu.items && activeIndex === index" class="dropdown-menu">
          <li
            v-for="(item, subIndex) in menu.items"
            :key="item.id || subIndex"
            @mouseenter="handleSubMouseEnter(index, subIndex)"
            @mouseleave="handleSubMouseLeave"
          >
            <span
              @click="
                handleItemClick(item, menu.titleKey, item.id == '1' ? '1' : '2')
              "
            >
              {{
                menu.titleKey === "Product_Center"
                  ? locale === "zh-cn"
                    ? item.translations["zh-cn"].cname
                    : item.translations["en"].cname
                  : $t("system.home.menu." + item.titleKey)
              }}
            </span>
            <!-- 二级下拉菜单 -->
            <ul
              v-if="item.children && activeSubIndex === subIndex"
              class="sub-dropdown-menu"
            >
              <li
                v-for="(subItem, subSubIndex) in item.children"
                :key="subItem.id || subSubIndex"
                @mouseenter="
                  handleSubSubMouseEnter(index, subIndex, subSubIndex)
                "
                @mouseleave="handleSubSubMouseLeave"
              >
                <span @click="handleItemClick(subItem, menu.titleKey, item.id)">
                  {{
                    menu.titleKey === "Product_Center"
                      ? locale === "zh-cn"
                        ? subItem.translations["zh-cn"].cname
                        : subItem.translations["en"].cname
                      : $t("system.home.menu." + subItem.titleKey)
                  }}
                </span>
                <!-- 三级下拉菜单 -->
                <!-- <ul
                  v-if="subItem.children && activeSubSubIndex === subSubIndex"
                  class="sub-sub-dropdown-menu"
                >
                  <li
                    v-for="(subSubItem, subSubSubIndex) in subItem.children"
                    :key="subSubItem.id || subSubSubIndex"
                    @mouseenter="
                      handleSubSubSubMouseEnter(
                        index,
                        subIndex,
                        subSubIndex,
                        subSubSubIndex
                      )
                    "
                    @mouseleave="handleSubSubSubMouseLeave"
                  >
                    <span
                      @click="
                        handleItemClick(subSubItem, menu.titleKey, item.id)
                      "
                    >
                      {{
                        menu.titleKey === "Product_Center"
                          ? locale === "zh-cn"
                            ? subSubItem.translations["zh-cn"].cname
                            : subSubItem.translations["en"].cname
                          : $t("system.home.menu." + subItem.titleKey)
                      }}
                    </span>
                    <ul
                      v-if="
                        subSubItem.children &&
                        activeSubSubSubIndex === subSubSubIndex
                      "
                      class="sub-sub-dropdown-menu"
                    >
                      <li
                        v-for="(fourthItem, fourthIndex) in subSubItem.children"
                        :key="fourthItem.id || fourthIndex"
                      >
                        <span
                          @click="
                            handleItemClick(fourthItem, menu.titleKey, item.id)
                          "
                        >
                          {{
                            menu.titleKey === "Product_Center"
                              ? locale === "zh-cn"
                                ? fourthItem.translations["zh-cn"].cname
                                : fourthItem.translations["en"].cname
                              : $t("system.home.menu." + fourthItem.titleKey)
                          }}
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul> -->
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import axios from "./../../../utils/axios";
import { useRouter } from "vue-router";
import { ref, onMounted, ssrContextKey } from "vue";
import { useI18n } from "vue-i18n";
const router = useRouter();
// 获取当前语言环境
const { locale } = useI18n();
import { useBreadcrumbStore } from "@/stores/breadcrumb";
const breadcrumbStore = useBreadcrumbStore();
const menus = ref([
  {
    titleKey: "home",
    route: "/home",
  },
  {
    titleKey: "Product_Center",
    items: [],
  },
  {
    titleKey: "aboutUs",
    items: [
      { titleKey: "companyIntroduction", route: "/about/company" },
      { titleKey: "qualityControl", route: "/about/quality" },
      { titleKey: "efficient", route: "/about/efficient" },
      { titleKey: "digital", route: "/about/digital" },
      { titleKey: "marketing", route: "/about/marketing" },
      { titleKey: "partner", route: "/about/partner" },
      { titleKey: "social", route: "/about/social" },
    ],
  },
  {
    titleKey: "news",
    // route: "/news",
    items: [
      { titleKey: "news", route: "/news/new" },
      // { titleKey: "mediaCenter", route: "/news/media" },
    ],
  },
  {
    titleKey: "contactUs",
    route: "/contact/contactWay",
    //     items: [
    //   { titleKey: "contactWay", route: "/contact/contactWay" },
    //    { titleKey: "register", route: "/contact/register" },
    // ],
  },
  // {
  //   titleKey: "talentPlan",
  //   route: "/talentPlan",
  // },
]);

const activeIndex = ref<number | null>(null);
const activeSubIndex = ref<number | null>(null);
const activeSubSubIndex = ref<number | null>(null);
const activeSubSubSubIndex = ref<number | null>(null);

let menuTimeout: NodeJS.Timeout | null = null;
let subMenuTimeout: NodeJS.Timeout | null = null;
let subSubMenuTimeout: NodeJS.Timeout | null = null;
let subSubSubMenuTimeout: NodeJS.Timeout | null = null;

const activeProductId = ref<number | null>(null); // 活动产品ID
const getTranslatedText = (
  translations: any,
  key: string,
  defaultText: string = ""
) => {
  if (!translations) return defaultText;
  return (
    translations[locale.value]?.[key] ||
    translations["zh-cn"]?.[key] ||
    translations["en"]?.[key] ||
    defaultText
  );
};
// 处理鼠标进入一级菜单
const handleMouseEnter = (index: number) => {
  if (menuTimeout) {
    clearTimeout(menuTimeout);
  }
  activeIndex.value = index;
};
// 处理鼠标离开一级菜单
const handleMouseLeave = () => {
  menuTimeout = setTimeout(() => {
    activeIndex.value = null;
    activeSubIndex.value = null;
    activeSubSubIndex.value = null;
    activeSubSubSubIndex.value = null;
  }, 600);
};
// 处理鼠标进入二级菜单
const handleSubMouseEnter = (index: number, subIndex: number) => {
  if (subMenuTimeout) {
    clearTimeout(subMenuTimeout);
  }
  activeIndex.value = index;
  activeSubIndex.value = subIndex;
};

// 处理鼠标离开二级菜单
const handleSubMouseLeave = () => {
  subMenuTimeout = setTimeout(() => {
    activeSubIndex.value = null;
    activeSubSubIndex.value = null;
    activeSubSubSubIndex.value = null;
  }, 600);
};

// 处理鼠标进入三级菜单
const handleSubSubMouseEnter = (
  index: number,
  subIndex: number,
  subSubIndex: number
) => {
  if (subSubMenuTimeout) {
    clearTimeout(subSubMenuTimeout);
  }
  activeIndex.value = index;
  activeSubIndex.value = subIndex;
  activeSubSubIndex.value = subSubIndex;
};

// 处理鼠标离开三级菜单
const handleSubSubMouseLeave = () => {
  subSubMenuTimeout = setTimeout(() => {
    activeSubSubIndex.value = null;
    activeSubSubSubIndex.value = null;
  }, 600);
};

// 处理鼠标进入四级菜单
const handleSubSubSubMouseEnter = (
  index: number,
  subIndex: number,
  subSubIndex: number,
  subSubSubIndex: number
) => {
  if (subSubSubMenuTimeout) {
    clearTimeout(subSubSubMenuTimeout);
  }
  activeIndex.value = index;
  activeSubIndex.value = subIndex;
  activeSubSubIndex.value = subSubIndex;
  activeSubSubSubIndex.value = subSubSubIndex;
};

// 处理鼠标离开四级菜单
const handleSubSubSubMouseLeave = () => {
  subSubSubMenuTimeout = setTimeout(() => {
    activeSubSubSubIndex.value = null;
  }, 300);
};

// 判断菜单项是否处于活动状态
// 修改判断活动状态的方法
const isActive = (menuItem: any) => {
  const currentPath = router.currentRoute.value.path;
  const lang = router.currentRoute.value.params.lang || "zh";
  const pathMap = {
    Product_Center: [`/${lang}/home/product`, `/${lang}/home/productlist`],
    news: [`/${lang}/news`],
    contactUs: [`/${lang}/contact`],
    aboutUs: [`/${lang}/about`],
  };
  if (menuItem.titleKey === "home") {
    return currentPath === `/${lang}/home` || currentPath === `/${lang}`;
  }

  // 检查特殊路径映射
  if (pathMap[menuItem.titleKey]) {
    return pathMap[menuItem.titleKey].some((path) =>
      currentPath.includes(path)
    );
  }

  // 处理直接路由
  if (menuItem.route) {
    return currentPath === menuItem.route;
  }

  // 处理子菜单
  return menuItem.items?.some((item: any) =>
    currentPath.startsWith(item.route)
  );
};

// 判断标题是否处于活动状态
const isTitleActive = (menuItem: any) => {
  return (
    menuItem.items &&
    menuItem.items.some(
      (item: any) => item.route === router.currentRoute.value.path
    )
  );
};

// 处理菜单项点击
const handleItemClick = (
  menuItem: any,
  parentTitleKey?: string,
  category?: string
) => {
  if (parentTitleKey !== "Product_Center") {
    if (menuItem.route) {
      router.push(menuItem.route);
    }
    return;
  }

  if (menuItem.level === 2) {
    const breadcrumbs = [
      {
        title: getTranslatedText(menuItem.translations, "cname"),
        translations: menuItem.translations,
      },
    ];
    breadcrumbStore.setBreadcrumbs(breadcrumbs);
    router
      .push({
        path: "/home/product-system",
        query: {
          // 如果是子系统，传 systemId，否则传 menuId
          ...(menuItem.hasSystem === 1
            ? { systemId: menuItem.id }
            : { menuId: menuItem.id }),
          systemLayout: menuItem.systemLayout,
          parentId: category || "",
          // translations: JSON.stringify(menuItem.translations),
        },
      })
      .then(() => {
        window.location.reload();
      });
  }
  if (menuItem.level === 3) {
    const productCenter = menus.value.find(
      (menu) => menu.titleKey === "Product_Center"
    );
    let secondLevelItem;
    if (productCenter?.items) {
      for (const item of productCenter.items) {
        if (item.children) {
          secondLevelItem = item.children.find(
            (child) => child.id === menuItem.parentId
          );
          if (secondLevelItem) break;
        }
      }
    }
    let breadcrumbs = [
      {
        title: getTranslatedText(secondLevelItem?.translations, "cname"),
        translations: secondLevelItem?.translations,
      },
      {
        title: getTranslatedText(menuItem.translations, "cname"),
        translations: menuItem.translations,
      },
    ];
    breadcrumbStore.setBreadcrumbs(breadcrumbs);
    // 如果不是子系统，则跳转到产品列表
    if (menuItem.hasSystem !== 1) {
      router.push({
        path: "/home/productlist",
        query: { cid: menuItem.id },
      });
    }
  }
  // 需求改变 代码没删
  if (menuItem.level === 4) {
    const productCenter = menus.value.find(
      (menu) => menu.titleKey === "Product_Center"
    );
    const level1 = productCenter?.items?.find((item) =>
      item.children?.some((l2) =>
        l2.children?.some((l3) =>
          l3.children?.some((l4) => l4.id === menuItem.id)
        )
      )
    );

    const level2 = level1?.children?.find((item) =>
      item.children?.some((l3) =>
        l3.children?.some((l4) => l4.id === menuItem.id)
      )
    );

    const level3 = level2?.children?.find((item) =>
      item.children?.some((l4) => l4.id === menuItem.id)
    );
    let breadcrumbs = [
      {
        title: getTranslatedText(level2?.translations, "cname"),
        translations: level2?.translations,
      },
      {
        title: getTranslatedText(level3?.translations, "cname"),
        translations: level3?.translations,
      },
      {
        title: getTranslatedText(menuItem.translations, "cname"),
        translations: menuItem.translations,
      },
    ];
    breadcrumbStore.setBreadcrumbs(breadcrumbs);
    if (menuItem.hasSystem === 1) {
      router.push({
        path: "/home/productlist",
        query: { cid: menuItem.id },
      });
    }
  }
};

// 新增处理菜单点击的方法
const handleMenuClick = (menu: any) => {
  if (!menu.items) {
    handleItemClick(menu, menu.titleKey);
  }
};

// 获取菜单数据
const fetchMenuData = async () => {
  try {
    const response = await axios.get("/framework/product/list/tree");
    const menuData = response;
    // 打印产品中心动态的三级路由菜单
    console.log(menuData);
    const productCenterMenu = menus.value.find(
      (menu) => menu.titleKey === "Product_Center"
    );
    if (productCenterMenu) {
      productCenterMenu.items = menuData;
    }
  } catch (error) {
    console.error("获取菜单数据失败:", error);
  }
};

// 组件挂载时获取菜单数据
onMounted(() => {
  fetchMenuData();
});
</script>
<style lang="scss" scoped>
.menu {
  display: flex;
  justify-content: center;
  gap: 20px; // 减小间距
  // padding: 20px 0;
  position: relative;
}

.menu-item {
  position: relative;
  list-style-type: none;
  width: auto; // 自适应宽度
}

.menu-item-title {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  padding: 10px; // 调整内边距
  white-space: nowrap; // 防止文字换行
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  min-width: 120px;
  max-width: 200px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
  z-index: 1000;
  opacity: 0;
  transform-origin: top;
  animation: dropDown 0.3s ease forwards;
  margin-top: -5px;
}

.sub-dropdown-menu,
.sub-sub-dropdown-menu {
  position: absolute;
  top: -5px;
  left: 100%;
  min-width: 160px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
  opacity: 0;
  transform-origin: left;
  animation: slideRight 0.3s ease forwards;
  margin-left: 1px;
}

@keyframes dropDown {
  from {
    opacity: 0;
    transform: translateX(-50%) scaleY(0.8);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) scaleY(1);
  }
}

@keyframes slideRight {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.dropdown-menu li,
.sub-dropdown-menu li,
.sub-sub-dropdown-menu li {
  position: relative; // 确保父元素是相对定位
  padding: 8px 16px; // 减小内边距
  font-size: 14px;
  color: #333;
  transition: all 0.3s ease;
  white-space: nowrap;
  text-align: left;

  &:hover {
    background: #f5f7fa;
    color: #004080;

    > ul {
      display: block;
    }
  }

  span {
    display: block;
    position: relative;
    padding: 2px 0;
  }
}

.title_text {
  position: relative;
  padding: 0 4px;
  color: #333;
  transition: color 0.3s ease;
  &:hover {
    color: #004080; // 添加悬浮时的颜色变化
  }
  &::after {
    content: "";
    position: absolute;
    bottom: -4px;
    left: 50%; // 从中间开始
    width: 0;
    height: 2px;
    background: #004080;
    transition: all 0.3s ease;
    transform: translateX(-50%); // 居中对齐
  }
  &:hover::after {
    width: 100%; // 悬浮时展开到100%宽度
  }
}

.menu-item-title.active .title_text,
.menu-item-title.text .title_text {
  color: #004080;

  &::after {
    width: 100%;
  }
}
</style>
